import WKT from "ol/format/WKT";
import * as project from "@/api/project.js";
import { setLayer } from "@/utils/map.js";

export default {
  state: {
    release: {},
  },
  getters: {
    getIsRelease: (state) => Boolean(state.release && state.release.id),
    getRelease: (state) => state.release,
  },
  mutations: {
    SET_RELEASE(state, payload) {
      state.release = payload;
      if (payload.id) {
        this.commit("SET_LAYERS", payload.ol_layers);
      }
    },
  },
  actions: {
    // Release
    loadRelease({ commit }, payload) {
      commit("SET_LOADING", true);
      project
        .getRelease(payload)
        .then((res) => {
          console.log(res.data);
          // Clear Task, Project.
          commit("SET_PROJECT", {});
          commit("SET_TASK", {});
          commit("CLEAR_ACTIVE_LAYERS");
          commit("CLEAR_FILTER");
          commit("CLEAR_HIDE");
          commit("CLEAR_SHOW");

          let payload = res.data;
          // OL Layer.
          let ol_layers = [];
          payload.layers.forEach((layer) => {
            layer.visible = true;
            layer.is_release = true;
            ol_layers.push(setLayer(layer, payload.id));
          });

          payload.ol_layers = ol_layers;

          let archive = res.data.archive;
          let task = archive.task;
          commit("SET_ALL_FEATURE_PROPERTIES", archive.properties);

          if (task.zoom_level) commit("SET_ZOOM", task.zoom_level);
          if (task.location_wkt) {
            try {
              var format = new WKT();
              const location_wkt = format.readFeature(task.location_wkt, {
                dataProjection: "EPSG:4326",
                featureProjection: "EPSG:4326",
              });
              commit("SET_CENTER", location_wkt.getGeometry().flatCoordinates);
              commit("SET_IS_CENTER_UPDATE", true);
            } catch (e) {
              console.log(e);
            }
          }

          commit("SET_RELEASE", payload);
          commit("SET_LOADING", false);
          // 릴리즈탭으로 바꾸기
          commit("SET_ACTIVE_TAB", "배포");
        })
        .catch(() => {
          commit("SET_SUCCESS", {
            title: "배포된 작업 불러오기에 실패하였습니다.",
          });
          commit("SET_LOADING", false);
        });
    },
  },
};
